module.exports = __webpack_public_path__ + "static/media/logo_dark.18a75ff2.png";